export default function WindowsDoorTypesElPaso() {
  const types = [
    {
      image: 'https://public.readdy.ai/ai/img_res/a1b49cfa2240bf6f197587737cbe317c.jpg',
      title: 'Vinyl Replacement Windows',
      features: ['Energy Star Rated', 'Low Maintenance', 'UV Protection', 'Lifetime Warranty'],
      description: 'Durable, energy-efficient vinyl windows perfect for El Paso\'s climate with excellent insulation and minimal upkeep requirements'
    },
    {
      image: 'https://readdy.ai/api/search-image?query=beautiful%20solid%20wood%20entry%20door%20with%20decorative%20glass%20inserts%20and%20elegant%20hardware%20installed%20in%20upscale%20home%20entrance%20with%20professional%20craftsmanship%20and%20warm%20welcoming%20appearance%20in%20residential%20setting&width=600&height=400&seq=windowsdoor-type-2&orientation=landscape',
      title: 'Wood Entry Doors',
      features: ['Custom Designs', 'Premium Materials', 'Enhanced Security', 'Classic Beauty'],
      description: 'Handcrafted wood doors offering timeless elegance, superior insulation, and customizable designs to match your home style'
    },
    {
      image: 'https://readdy.ai/api/search-image?query=modern%20sliding%20patio%20glass%20door%20system%20with%20large%20transparent%20panels%20connecting%20indoor%20living%20space%20to%20outdoor%20patio%20area%20with%20aluminum%20frame%20and%20smooth%20operation%20in%20contemporary%20home%20setting&width=600&height=400&seq=windowsdoor-type-3&orientation=landscape',
      title: 'Sliding Patio Doors',
      features: ['Space Saving', 'Wide Openings', 'Easy Operation', 'Weather Sealed'],
      description: 'Contemporary sliding door systems that maximize natural light and provide seamless access to outdoor living areas'
    },
    {
      image: 'https://readdy.ai/api/search-image?query=elegant%20bay%20window%20installation%20with%20multiple%20glass%20panels%20creating%20extended%20interior%20space%20and%20panoramic%20views%20in%20residential%20home%20with%20cushioned%20seating%20area%20and%20natural%20lighting%20in%20modern%20setting&width=600&height=400&seq=windowsdoor-type-4&orientation=landscape',
      title: 'Bay & Bow Windows',
      features: ['Panoramic Views', 'Added Space', 'Architectural Interest', 'Natural Light'],
      description: 'Stunning bay and bow window installations that create additional interior space while enhancing curb appeal'
    },
    {
      image: 'https://readdy.ai/api/search-image?query=durable%20fiberglass%20entry%20door%20with%20realistic%20wood%20grain%20texture%20and%20modern%20hardware%20installed%20in%20home%20entrance%20with%20weather%20resistant%20finish%20and%20superior%20insulation%20in%20residential%20exterior%20setting&width=600&height=400&seq=windowsdoor-type-5&orientation=landscape',
      title: 'Fiberglass Doors',
      features: ['Weather Resistant', 'Low Maintenance', 'Energy Efficient', 'Dent Resistant'],
      description: 'High-performance fiberglass doors combining the beauty of wood with superior durability and energy efficiency'
    },
    {
      image: 'https://readdy.ai/api/search-image?query=elegant%20french%20patio%20doors%20with%20divided%20glass%20panels%20and%20traditional%20styling%20opening%20to%20outdoor%20space%20with%20symmetrical%20design%20and%20classic%20hardware%20in%20upscale%20residential%20home%20setting&width=600&height=400&seq=windowsdoor-type-6&orientation=landscape',
      title: 'French Doors',
      features: ['Classic Style', 'Full Glass Panels', 'Interior/Exterior', 'Elegant Design'],
      description: 'Traditional French door installations offering timeless elegance and abundant natural light for any room'
    }
  ];

  return (
    <section className="py-20 bg-gray-50">
      <div className="max-w-7xl mx-auto px-6">
        <div className="text-center mb-16">
          <h2 className="text-4xl font-bold text-gray-900 mb-4">
            Popular Window & Door Options in El Paso
          </h2>
          <p className="text-lg text-gray-600 max-w-3xl mx-auto">
            Explore the most requested window and door replacement options designed for El Paso's unique climate and architectural styles
          </p>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
          {types.map((type, index) => (
            <div 
              key={index}
              className="bg-white rounded-xl overflow-hidden shadow-md hover:shadow-xl transition-shadow"
            >
              <div className="w-full h-64">
                <img
                  src={type.image}
                  alt={type.title}
                  className="w-full h-full object-cover object-top"
                />
              </div>
              <div className="p-6">
                <h3 className="text-xl font-bold text-gray-900 mb-3">
                  {type.title}
                </h3>
                <p className="text-gray-600 mb-4 leading-relaxed">
                  {type.description}
                </p>
                <div className="flex flex-wrap gap-2">
                  {type.features.map((feature, idx) => (
                    <span 
                      key={idx}
                      className="px-3 py-1 bg-teal-50 text-teal-700 rounded-full text-sm font-medium"
                    >
                      {feature}
                    </span>
                  ))}
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
